
import { defineComponent, computed } from 'vue'
import { useDailyReport } from '@/composable/useDailyReport'
import { useProfile } from '@/composable/useProfile'

export default defineComponent({
  name: 'DailyReportSummaryTable',

  setup() {
    const { isPrintMode, data } = useDailyReport()
    const { currentProject } = useProfile()
    // const colStyle = 'white-space: pre-wrap'
    const columns = [
      {
        align: 'left',
        name: 'punctualityShuttle',
        label: 'Helt inställda tåg',
        field: 'punctualityShuttle',
      },
      {
        align: 'left',
        name: 'punctualityRegion',
        label: 'Delvis inställda tåg',
        field: 'punctualityRegion',
      },

      {
        align: 'left',
        name: 'deviatingCrew',
        label: 'Korta tåg',
        field: 'deviatingCrew',
        style: '',
      },

      {
        align: 'left',
        name: 'deviations',
        label: 'Slopade uppehåll',
        field: 'deviations',
        style: '',
      },
    ]

    const rows = computed(() => {
      return [
        {
          punctualityShuttle: data.value.summary.rows
            .find((x) => x.label === 'Helt inställda tåg')
            ?.data.find((t) => t.name === 'Helt inställda tåg')?.count,
          punctualityRegion: data.value.summary.rows
            .find((x) => x.label === 'Delvis inställda tåg')
            ?.data.find((t) => t.name === 'Delvis inställda tåg')?.count,
          shortTrain: data.value.summary.rows
            .find((x) => x.label === 'Korta tåg')
            ?.data.find((t) => t.name === 'Korta tåg')?.count,
          deviations: data.value.summary.rows
            .find((x) => x.label === 'Slopade uppehåll')
            ?.data.find((t) => t.name === 'Slopade uppehåll')?.count,
        },
      ]
    })

    return { rows, columns, isPrintMode, currentProject }
  },
})
